export default {"src":"/_next/static/media/question_mark.4d3e9479.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};